import { render, staticRenderFns } from "./DownloadXlsxCsv.vue?vue&type=template&id=2bb2f7af"
import script from "./DownloadXlsxCsv.vue?vue&type=script&lang=js"
export * from "./DownloadXlsxCsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports